import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Theme: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.' }
      ]
    },
    Notes: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'CONTACT US',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event',
            options: [
              { label: 'Leadership Training', value: 'Leadership Training' },
              { label: 'Corporate Meeting', value: 'Corporate Meeting' },
              { label: 'Reunion', value: 'Reunion' },
              { label: 'Other Event', value: 'Other Event' }
            ],
            mapping: 'Theme'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Expected Attendance',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Tell us about your gathering',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Alnoba Contact Form',
    formId: '591',
    clientKey: '395179A4-1605-481B-90B3-71507E0D1512',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/alnoba/form_structure.js